<template>
  <div class="pay_order">
    <van-sticky>
      <van-nav-bar title="支付订单" left-arrow @click-left="goback()" />
    </van-sticky>
    <div class="order_number">累计提成： +{{detail.totalCash}}元</div>
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" :immediate-check="false">
        <van-tabs :v-modelActive="active" title-active-color="#FCA33D" color="#FCA33D" @click="onClickTabs">
          <van-tab v-for="(items, indexs) in title" :key="indexs" :title="items">
            <div class="order_list" v-for="(item, index) in orderList" :key="index">
              <div>分销等级：{{ item.distributorLevel }}</div>
              <div>订单编号：{{item.order_info_orderNumber}}</div>
              <div>下单时间：{{item.order_info_createtime}}</div>
              <div class="list_price">预计提成：+ <span>{{item.amount}}</span></div>
            </div>
            <van-empty v-if="orderList.length == 0" description="暂无订单" />
          </van-tab>
        </van-tabs>
      </van-list>
    </van-pull-refresh>
  </div>
</template>
<script>
import { Button, NavBar, Icon, Sticky, Tab, Tabs, Empty, Toast, PullRefresh, List, Notify, } from "vant";
export default {
  components: {
    [Button.name]: Button,
    [Icon.name]: Icon,
    [NavBar.name]: NavBar,
    [Sticky.name]: Sticky,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Empty.name]: Empty,
    [PullRefresh.name]: PullRefresh,
    [List.name]: List,
  },
  data() {
    return {
      loading: false, //底部加载状态
      finished: false, //底部是否完成状态
      isLoading: false,
      detail: {
        "totalCash": 0,
        "canCash": 0,
        "appliedCash": 0,
        "waitCash": 0,
        "rejectCash": 0,
        "alreadyCash": 0
      },
      active: 0,
      orderList: [],
      title: ["所有", "待付款", "已付款", "已完成"],
      page: 1,
      size: 10,
      total: 0,
    };
  },
  mounted() {
    this.getCashInfo();
    this.getPayOrderInfo();
  },
  methods: {
    //返回上一页
    goback() {
      if (window.history.length <= 1) {
        this.$router.push({ path: "/" });
        return false;
      } else {
        this.$router.go(-1);
      }
    },

    //跳转立即租赁
    toSiteLease() {
      this.$router.push({ path: "/home/siteLease" });
    },

    //跳转立即预约
    toSiteSubscribe() {
      this.$router.push({ path: "/home/siteSubscribe" });
    },

    //获取分销佣金
    getCashInfo() {
      let that = this;
      that.$api.userH5ApplyCashAPI("").then(function(res) {
        if (res.data.code == 200) {
          that.detail = res.data.data
        } else {
          Notify({ type: "danger", message: '接口返回异常：' + res.data.message });
        }
      }).catch(function(err) {
        Notify({ type: "danger", message: JSON.stringify(err) });
      })
    },

    //获取支付订单
    getPayOrderInfo(isLoadMore = false) {
      let that = this;
      that.$api.userH5ApplyPayListAPI({
        status: that.active,
        page: that.page,
        size: that.size,
      }).then(function(res) {
        if (res.data.code == 200) {
          if (that.page > 1) {
            that.orderList = (!isLoadMore && res.data.dataList.length != 0) ? res.data.dataList : that.orderList;
            that.orderList = (isLoadMore && res.data.dataList.length != 0) ? that.orderList.contact(res.data.dataList) : that.orderList
          } else {
            that.orderList = res.data.dataList
          }
          that.total = res.data.total
          if (res.data.dataList.length == 0 && that.page > 1)
            that.finished = true
        } else {
          Notify({ type: "danger", message: '接口返回异常：' + res.data.message });
        }
      }).catch(function(err) {
        Notify({ type: "danger", message: JSON.stringify(err) });
      })
    },

    //切换订单状态
    onClickTabs(e) {
      //console.log('订单状态：'+e)
      this.active = e
      this.getPayOrderInfo()
    },

    //下拉刷新
    onRefresh() {
      let that = this
      that.page = 1;
      setTimeout(() => {
        that.isLoading = false
        that.getPayOrderInfo()
      }, 1000);
    },

    //上拉加载
    onLoad() {
      let that = this;
      that.page = that.page + 1
      setTimeout(() => {
        that.getPayOrderInfo(true);
      }, 1000);
    },
  }
};

</script>
<style lang="less" scoped>
.pay_order {
  .order_number {
    background: #fca33d;
    padding: 15px;
    font-size: 14px;
    color: #fff;
  }

  .order_list {
    border-top: 10px solid #f3f3f1;
    font-size: 11px;
    color: #999;

    div {
      padding: 10px;
      padding-bottom: 0px;
    }

    .list_price {
      border-top: 1px solid #f3f3f3;
      padding: 15px;
      color: #000;
      margin-top: 10px;
      text-align: end;

      span {
        font-size: 16px;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/views/layout/distribution/payOrder.vue